export const SEARCH_PER_PAGE_RESULTS = 48